import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { UserContext } from "../common/UserContext"
import config from "../../envconfig";

const Chart3 = () => {
    const [statusCounts, setStatusCounts] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const chartAreaRef = useRef(null);
    const chartId = "scp-status-chart";
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
    console.log("(((((((((((****************&&&&&&&&");

    useEffect(() => {
        const fetchStatusCounts = async () => {
            try {
                const response = await axios.get(`${config.API_URL}/scpwidget/${UM_CompanyID}`);
                setStatusCounts(response.data);
                console.log("SCPPPPPPPPPPPPPPPPPPP-", response.data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchStatusCounts();
    }, [UM_CompanyID]);

    // Extract labels and series from statusCounts
    const labels = statusCounts.map(item => item.StatusDescription);
    const series = statusCounts.map(item => item.StatusCount);

    // const chartOptions = {
    //     labels: labels,
    //     colors: [
    //         "#4AB97D",         // Active
    //         "#D25141",       // Inactive
    //         "#6395EC",      // Suspend
    //         // "rgba(8, 17, 24)",  // Red for Suspend
    //         // "rgba(39, 85, 121)",  // Light Blue for Active
    //         // "rgba(86, 151, 201)",  // Orange for Inactive
    //     ],
    //     legend: {
    //         position: 'left',
    //         offsetX: -35,
    //         offsetY: 0,
    //         floating: false,
    //         verticalAlign: 'top',
    //         horizontalAlign: 'center',
    //         width: 150, // Adjust width as needed
    //         height: 'auto',
    //         formatter: function (val, opts) {
    //             // Format the legend text with StatusCount
    //             const count = series[opts.seriesIndex];
    //             return `${val}: ${count}`;
    //         },
    //     },
    //     title: {
    //         text: 'SCP',
    //         align: 'left',
    //         margin: 10,
    //         marginBottom: 30,
    //         offsetY: 0,
    //         style: {
    //             fontSize: '16px',
    //             fontWeight: 'bold',
    //             color: '#2B2A29',

    //         }
    //     },
    //     tooltip: {
    //         enabled: true,
    //         y: {
    //             formatter: function (value, { seriesIndex, w }) {
    //                 const label = chartOptions.labels[seriesIndex];
    //                 return `${label} : ${value}`;
    //             },
    //             title: {
    //                 formatter: () => ''
    //             }
    //         }
    //     }
    // };
const chartOptions = {
    chart: {
        id: chartId,
        events: {
            dataPointSelection: function (event, chartContext, config) {
                const { dataPointIndex, selectedDataPoints } = config;
                const selectedIndexes = Array.isArray(selectedDataPoints?.[0]) ? selectedDataPoints[0] : [];
                if (selectedIndexes.includes(dataPointIndex)) {
                    setSelectedDataPoint(dataPointIndex);
                } else {
                    setSelectedDataPoint(null);
                }
            },
        },
    },
    labels: labels,
    colors: ["#4AB97D", "#D25141", "#6395EC"],
    legend: {
        position: 'left',
        offsetX: -35,
        offsetY: 20, // pushes the whole legend downward
        floating: false,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        width: 150,
        height: 'auto',
        labels: {
            useSeriesColors: false,
            style: {
                fontSize: '14px',
                fontWeight: 500,
                colors: '#333',
            }
        },
        itemMargin: {
            horizontal: 5,
            vertical: 5   // <-- this adds margin-top between legend labels
        },
        formatter: function (val, opts) {
            const count = series[opts.seriesIndex];
            return `${val} : ${count}`;
        },
    },
    title: {
        text: 'SCP',
        align: 'left',
        margin: 10,
        offsetY: 0,
        style: {
            fontSize: '16px',
            fontWeight: 'bold',
            color: '#2B2A29',
        }
    },
    tooltip: {
        enabled: true,
        y: {
            formatter: function (value, { seriesIndex }) {
                const label = chartOptions.labels[seriesIndex];
                return `${label} : ${value}`;
            },
            title: {
                formatter: () => ''
            }
        }
    }
};

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (selectedDataPoint === null) return;
            if (chartAreaRef.current && !chartAreaRef.current.contains(event.target)) {
                ApexCharts.exec(chartId, "toggleDataPointSelection", selectedDataPoint);
                setSelectedDataPoint(null);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, [selectedDataPoint]);

    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row' }}>
            <div ref={chartAreaRef} style={{ flexGrow: 1, zIndex: 1 }}>

                <ReactApexChart options={chartOptions} series={series} type="pie" height="100%" />

            </div>
        </div>
    );
};

export default Chart3;


// fine 
